import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Meteor = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M9.5 22c2.003 0 3.887-.78 5.313-2.207l6.904-7.096A1 1 0 0021 11h-3.301l4.175-7.514a1.001 1.001 0 00-1.359-1.36l-7.11 3.95.576-2.879a1 1 0 00-1.629-.957L4.196 9.197c-2.924 2.924-2.924 7.682 0 10.606A7.452 7.452 0 009.5 22zM5.552 10.665l5.902-5.031-.248 1.24-.186.93v.001l-.424 2.119 7.83-4.35-3.3 5.94-.001.001L14.301 13h4.331l-5.243 5.389C12.35 19.428 10.969 20 9.5 20s-2.851-.572-3.89-1.611c-2.143-2.144-2.143-5.634-.058-7.724z",
    key: "k0"
  }), React.createElement("path", {
    d: "M9.5 18a3.492 3.492 0 001.484-6.659c.005.053.016.105.016.159a1.5 1.5 0 11-3 0c0-.054.011-.106.016-.159A3.492 3.492 0 009.5 18z",
    key: "k1"
  }));
});
Meteor.displayName = 'Meteor';
export var MeteorDimensions = {
  height: 24,
  width: 24
};